import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useOutletContext } from "react-router-dom";
import STAFF_IMAGE from "../../../assets/images/avatars/default.png";
import PageTitle from "../../../components/partials/PageTitle";
import { useSelector, useDispatch } from "react-redux";
import useInputChange from "./../../../utils/hooks/useInputChange";
import Form from "../../../components/form/Form";
import useFileSelected from "./../../../utils/hooks/useFileSelected";
import { isEmptyObject } from "./../../../utils/validators/validators";
import {
  addStaffGuarantorInfo,
  resetStaffStatus,
} from "./../../../redux/slice/staff/staffSlice";
import PhoneInput from "react-phone-number-input";

const AddGuarantorInfo = () => {
  const [error, setError] = useState({});
  const { app_id, staff_records, pages, isSuccess, isLoading, isError } =
    useSelector((state) => state.staff);
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { nextPage } = useOutletContext();

  const [staffInputData, setStaffInputData] = useState({
    fullname: "",
    phone_number: "",
    address: "",
    relationship_with_staff: "",
    years_known_staff: "",
    working_segment: "",
    image: {},
    app_id: app_id,
  });
  const [input, handleChange] = useInputChange(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );
  const [fileInput, fileChangeHandler] = useFileSelected(
    staffInputData,
    setStaffInputData,
    error,
    setError
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const passportRef = useRef();

  const [phoneNumber, setPhoneNumber] = useState("");
  const [borderColor, setBorderColor] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (phone_no) => {
    if (!phone_no) {
      setBorderColor("#fa5c7c");
      setErrorMessage("Please enter phone number");
    } else {
      setBorderColor("");
      setErrorMessage("");
      setPhoneNumber(phone_no);
    }
    setStaffInputData(staffInputData);
  };

  const handleSubmit = () => {
    if (isEmptyObject(error)) {
      if (!phoneNumber) {
        setBorderColor("#fa5c7c");
        setErrorMessage("Please enter phone number");
        return;
      }
      dispatch(
        addStaffGuarantorInfo({ ...staffInputData, phone_number: phoneNumber })
      );
    }
  };

  const breadcrumb = {
    from: {
      title: "Staff",
      link: "/admin/add-staff",
    },
    current: {
      title: "guarantor information",
      link: null,
    },
  };

  useEffect(() => {
    !app_id
      ? navigate(-1)
      : nextPage &&
        navigate(nextPage, { state: { from: location }, replace: true });
  }, [pages]);

  useEffect(() => {
    if (isSuccess) {
      navigate("/admin/add-staff/work-experience", {
        state: { from: location },
        replace: true,
      });
    }
    return () => {
      dispatch(resetStaffStatus());
    };
  }, [staff_records, isError, isSuccess, isLoading]);

  useEffect(() => {
    if (
      !user_permissions?.some(
        (permission) => permission.name === "staff module"
      ) ||
      !user_permissions?.some(
        (permission) => permission.name === "create staff"
      )
    ) {
      navigate("/admin/dashboard");
    }
  }, [navigate, user_permissions]);
  return (
    <>
      {/* page title */}
      <PageTitle title='Staff Creation' breadcrumb={breadcrumb} />
      {/* end page title */}

      {/* content */}
      <div className='row'>
        <div className='col-md-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row pb-2 mb-3 text-capitalize border-bottom'>
                <div className='col-md-12 d-flex justify-content-between align-items-center'>
                  <h4 className='header-title text-uppercase mb-0 text-primary'>
                    Guarantor Information
                  </h4>
                </div>
              </div>
              <Form
                setError={setError}
                submitHandler={handleSubmit}
                values={staffInputData}
              >
                <div className='row g-'>
                  <div className='mb-0 col-md-6'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Full Name <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='2'
                      textname='full name'
                      name='fullname'
                      onChange={handleChange}
                      value={input.fullname}
                      type='text'
                      className={`form-control ${
                        error.fullname && "is-invalid"
                      }`}
                      id='inputEmail4'
                      placeholder='Full Name'
                    />
                    {error.fullname && (
                      <span className='invalid-feedback'>{error.fullname}</span>
                    )}
                  </div>
                  <div className='col-md-6 mb-3'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Phone Number
                      <span className='text-danger'>*</span>
                    </label>

                    <PhoneInput
                      placeholder='Enter phone number'
                      value={phoneNumber}
                      onChange={handlePhoneNumberChange}
                      onBlur={(e) => {
                        if (!e.target.value) {
                          setBorderColor("#fa5c7c");
                          setErrorMessage("Phone number is required.");
                        } else {
                          setBorderColor("");
                          setErrorMessage("");
                        }
                      }}
                      defaultCountry='NG'
                      className='form-control custom-phone-input'
                      style={{ borderColor: `${borderColor}` }}
                    />
                    {errorMessage && (
                      <span className='text-danger text-sm'>
                        {errorMessage}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='mb-3'>
                    <label htmlFor='address' className='form-label'>
                      Address <span className='text-danger'>*</span>
                    </label>
                    <textarea
                      min_length='5'
                      textname='address'
                      rows='6'
                      name='address'
                      value={input.address}
                      onChange={handleChange}
                      id='address'
                      className={`form-control ${
                        error.address && "is-invalid"
                      }`}
                      placeholder='Enter address here'
                    ></textarea>
                    {error.address && (
                      <span className='invalid-feedback'>{error.address}</span>
                    )}
                  </div>
                </div>

                <div className='row g-'>
                  <div className='col-lg-6 col-xl-4 col-md-12 mb-3'>
                    <label htmlFor='inputEmail4' className='form-label'>
                      Working Segment <span className='text-danger'>*</span>
                    </label>
                    {/* <input 
                                              min_length='3'
                                              textname='working segment'
                                              name='working_segment'
                                              value={input.working_segment}
                                              onChange={handleChange}
                                              type="text"
                                              className={`form-control ${error.working_segment && 'is-invalid'}`} 
                                              placeholder='Working Segment (e.g business person, clergy, civil servant)'
                                            /> */}
                    <select
                      name='working_segment'
                      id='working_segment'
                      textname='working segment'
                      value={input.working_segment}
                      onChange={handleChange}
                      className={`form-select ${
                        error.working_segment && "is-invalid"
                      }`}
                    >
                      <option value=''>Choose Working Segment</option>
                      <option value='Business Person'>Business Person</option>
                      <option value='Clergy'>Clergy</option>
                      <option value='Civil Servant'>Civil Servant</option>
                    </select>
                    {error.working_segment && (
                      <span className='invalid-feedback'>
                        {error.working_segment}
                      </span>
                    )}
                  </div>
                  <div className='col-lg-6 col-xl-4 col-md-12 mb-3'>
                    <label htmlFor='example-textarea' className='form-label'>
                      Relationship with staff{" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='4'
                      textname='relationship'
                      name='relationship_with_staff'
                      value={input.relationship_with_staff}
                      onChange={handleChange}
                      id='relationship_with_staff'
                      className={`form-control ${
                        error.relationship_with_staff && "is-invalid"
                      }`}
                      placeholder='Relationship with staff'
                    />
                    {error.relationship_with_staff && (
                      <span className='invalid-feedback'>
                        {error.relationship_with_staff}
                      </span>
                    )}
                  </div>
                  <div className='col-lg-12 col-xl-4 col-md-12 mb-3'>
                    <label htmlFor='example-textarea' className='form-label'>
                      How long have you known the staff{" "}
                      <span className='text-danger'>*</span>
                    </label>
                    <input
                      min_length='1'
                      textname='duration'
                      name='years_known_staff'
                      value={input.years_known_staff}
                      onChange={handleChange}
                      id='years_known_staff'
                      className={`form-control ${
                        error.years_known_staff && "is-invalid"
                      }`}
                      placeholder='Please enter duration'
                    />
                    {error.years_known_staff && (
                      <span className='invalid-feedback'>
                        {error.years_known_staff}
                      </span>
                    )}
                  </div>
                </div>

                <div className='row g-2'>
                  <div className='passport-container d-flex gap-4'>
                    <div className='input-wrapper'>
                      <label
                        className='btn btn-primary rounded-0'
                        htmlFor='passport'
                        onClick={() => {
                          passportRef.current.click();
                        }}
                      >
                        Choose Passport
                      </label>
                      <input
                        textname='passport'
                        className='d-none'
                        accept='image/*'
                        type='file'
                        name='image'
                        onChange={fileChangeHandler}
                        ref={passportRef}
                      />
                      {error.image && (
                        <span className='d-block text-danger mt-2'>
                          {error.image}
                        </span>
                      )}
                    </div>
                    <div className='passport mb-4'>
                      <img
                        src={
                          staffInputData?.temp_url && staffInputData?.temp_url
                        }
                        width='100'
                        alt=''
                      />
                    </div>
                  </div>
                </div>

                <div className='float-end'>
                  <button
                    disabled={isLoading && true}
                    className='btn btn-primary w-10'
                  >
                    Proceed
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      {/* end content */}
    </>
  );
};

export default AddGuarantorInfo;
